import { createSelector } from 'reselect';

import { AppState } from '../types';

export const getBooking = (state: AppState) => state.booking;

export const getIsRatingWindowExpired = createSelector(getBooking, booking => booking?.ratingWindowExpired ?? false);
